export const DEFAULT_PRODUCT_IMAGE = /*process.env.PUBLIC_URL + */ '/images/no_image_available-01.svg'
export const TEXT_REGEX = /^(\w|\s|[-_'&()+À-ÿ])*$/

export const LANGUAGE_CODES_LOCALE = {
    us: 'en-US',
    en: 'en',
    fr: 'fr',
    de: 'de',
    it: 'it',
    es: 'es'
}

export const LANGUAGE_LOCALES_CODE = {
    'en-US': 'us',
    us: 'us',
    en: 'en',
    fr: 'fr',
    de: 'de',
    it: 'it',
    es: 'es'
}

export const PRODUCT_REGULAR_HANGING = ['pendantHeight']

export const PRODUCT_LIGHTING_ATTRIBUTES = {
	lumens: 'lumensLed',
	totalLumens: 'totalLumensLed',
	totalLeds: 'totalLeds',
	totalLuminaries: 'totalLuminaries'
}

export const PRODUCT_POWER_ATTRIBUTES = {
	power: 'watts',
	totalPower: 'totalWatts'
}

export const PRODUCT_LENGTH_ATTRIBUTES = {
	totalLength: 'totalLength',
	totalBeltLength: 'totalBeltLength'
}